import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Users = () => <MfeLoader port={process.env.NX_USERS_MFE_PORT!} mfeId={FEATURE_APP_ID.USERS_MFE} />

export default Users
